import {all} from 'redux-saga/effects';
import {addOptionSagaWatcher} from './options/add_option.saga';
import {changeOptionsVisibilitySagaWatcher} from './options/change_options_visibility.saga'
import {deleteOptionSagaWatcher} from './options/delete_option.saga'
import {deleteOptionsSagaWatcher} from './options/delete_options.saga'
import {getOptionSagaWatcher} from './options/get_option.saga';
import {getOptionsSagaWatcher} from './options/get_options.saga';
import {unDeleteOptionSagaWatcher} from './options/undelete_option.saga'
import {unDeleteOptionsSagaWatcher} from './options/undelete_options.saga'
import {updateOptionSagaWatcher} from './options/update_option.saga'


import {addExtraSagaWatcher} from './extras/add_extra.saga';
import {changeExtrasVisibilitySagaWatcher} from './extras/change_extras_visibility.saga'
import {deleteExtraSagaWatcher} from './extras/delete_extra.saga'
import {deleteExtrasSagaWatcher} from './extras/delete_extras.saga'
import {getExtraSagaWatcher} from './extras/get_extra.saga';
import {getExtrasSagaWatcher} from './extras/get_extras.saga';
import {unDeleteExtraSagaWatcher} from './extras/undelete_extra.saga'
import {unDeleteExtrasSagaWatcher} from './extras/undelete_extras.saga'
import {updateExtraSagaWatcher} from './extras/update_extra.saga'

import {addPromotionSagaWatcher} from './promotions/add_promotion.saga';
import {changePromotionsVisibilitySagaWatcher} from './promotions/change_promotions_visibility.saga'
import {deletePromotionSagaWatcher} from './promotions/delete_promotion.saga'
import {deletePromotionsSagaWatcher} from './promotions/delete_promotions.saga'
import {getPromotionSagaWatcher} from './promotions/get_promotion.saga';
import {getPromotionsSagaWatcher} from './promotions/get_promotions.saga';
import {unDeletePromotionSagaWatcher} from './promotions/undelete_promotion.saga'
import {unDeletePromotionsSagaWatcher} from './promotions/undelete_promotions.saga'
import {updatePromotionSagaWatcher} from './promotions/update_promotion.saga'


import {addProductSagaWatcher} from './productTypes/add_product.saga';
import {addProductTypeSagaWatcher} from './productTypes/add_productType.saga';
import {deleteProductSagaWatcher} from './productTypes/delete_product.saga'
import {deleteProductTypeSagaWatcher} from './productTypes/delete_productType.saga'
import {getProductTypeSagaWatcher} from './productTypes/get_productType.saga';
import {getProductTypesSagaWatcher} from './productTypes/get_productTypes.saga';
import {reOrderProductsSagaWatcher} from './productTypes/reorder_products.saga'
import {reOrderProductTypesSagaWatcher} from './productTypes/reorder_productTypes.saga'
import {transferProductSagaWatcher} from './productTypes/transfer_product.saga'
import {unDeleteProductTypeSagaWatcher} from './productTypes/undelete_productType.saga'
import {updateProductListsSagaWatcher} from './productTypes/update_product_lists.saga'
import {updateProductSagaWatcher} from './productTypes/update_product.saga'
import {updateProductTypeSagaWatcher} from './productTypes/update_productType.saga'

export default function* menuSaga() {
    yield all([
        addOptionSagaWatcher(),
        changeOptionsVisibilitySagaWatcher(),
        deleteOptionSagaWatcher(),
        deleteOptionsSagaWatcher(),
        getOptionSagaWatcher(),
        getOptionsSagaWatcher(),
        unDeleteOptionSagaWatcher(),
        unDeleteOptionsSagaWatcher(),
        updateOptionSagaWatcher(),

        addExtraSagaWatcher(),
        changeExtrasVisibilitySagaWatcher(),
        deleteExtraSagaWatcher(),
        deleteExtrasSagaWatcher(),
        getExtraSagaWatcher(),
        getExtrasSagaWatcher(),
        unDeleteExtraSagaWatcher(),
        unDeleteExtrasSagaWatcher(),
        updateExtraSagaWatcher(),

        addPromotionSagaWatcher(),
        changePromotionsVisibilitySagaWatcher(),
        deletePromotionSagaWatcher(),
        deletePromotionsSagaWatcher(),
        getPromotionSagaWatcher(),
        getPromotionsSagaWatcher(),
        unDeletePromotionSagaWatcher(),
        unDeletePromotionsSagaWatcher(),
        updatePromotionSagaWatcher(),

        addProductSagaWatcher(),
        addProductTypeSagaWatcher(),
        deleteProductSagaWatcher(),
        deleteProductTypeSagaWatcher(),
        getProductTypeSagaWatcher(),
        getProductTypesSagaWatcher(),
        reOrderProductsSagaWatcher(),
        reOrderProductTypesSagaWatcher(),
        transferProductSagaWatcher(),
        unDeleteProductTypeSagaWatcher(),
        updateProductListsSagaWatcher(),
        updateProductSagaWatcher(),
        updateProductTypeSagaWatcher(),
    ]);
}